export default __webpack_public_path__ + "img/77c687d83be1432b4850e485c400f352.jpg";